'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import React, { useImperativeHandle, useMemo, useRef } from 'react';
// Visual layout styles for the composer input. Owned here so the
// primitive is self-contained and consumers depend on composer-sdk one-way.
const containerStyles = {
    base: 'overflow-hidden relative flex h-full min-w-0',
    expanded: ['col-start-1', 'col-end-3', 'pb-2 ml-2 mt-1'],
    compact: ['items-center', 'grow', 'shrink', 'p-2', 'order-1'],
};
/** Presentational wrapper around composer input content (visual styles only). */
export const ComposerInput = ({ isExpanded, minRows, leadingAccessory, onClick, children, ref, }) => {
    const innerRef = useRef(null);
    const hasLeadingAccessory = leadingAccessory != null && leadingAccessory !== false;
    useImperativeHandle(ref, () => ({
        element: () => innerRef.current,
    }), []);
    const wrapperClass = useMemo(() => classNames(containerStyles.base, hasLeadingAccessory && 'gap-2', {
        [containerStyles.expanded.join(' ')]: isExpanded,
        [containerStyles.compact.join(' ')]: !isExpanded,
    }), [hasLeadingAccessory, isExpanded]);
    const style = useMemo(() => {
        const height = `${(isExpanded ? (minRows ?? 1) : 1) * 1.5}em`;
        return {
            minHeight: height,
            height: isExpanded ? undefined : height,
        };
    }, [isExpanded, minRows]);
    return (_jsxs("div", { className: wrapperClass, children: [hasLeadingAccessory && (_jsx("div", { className: classNames('shrink-0', !isExpanded && 'flex -translate-y-px items-center'), children: leadingAccessory })), _jsx("div", { className: classNames(
                // Children such as the placeholder and typeahead anchor are absolutely
                // positioned within this container, so set a `relative` class here.
                'relative', hasLeadingAccessory ? 'min-w-0 flex-1' : 'min-w-0 w-full'), style: style, ref: innerRef, onClick: onClick, children: children })] }));
};
//# sourceMappingURL=ComposerInput.js.map